@if (isLoading$ | async) {
    <div class="loading-overlay" [class.centered]="centered" [class.no-opacity]="noOpacity">
        <si-loading-spinner />
    </div>
}
